import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Redirect, Route, Switch } from 'react-router-dom';

import E404 from '../containers/e-404';
import Welcome from '../containers/welcome';

class AppRoutes extends React.Component<any, any> {
  public render() {
    return (
      <div>
        <Switch>
          <Route exact={true} path='/' component={E404} />
          <Route path='/welcome' component={Welcome} />
          <Redirect to='/' />
        </Switch>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return { ...state };
}

export default withRouter(connect(
  mapStateToProps
)(AppRoutes));




// WEBPACK FOOTER //
// ./src/routes/index.tsx